import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import TaskDo from "./TaskDo";
import { Header } from '../Header';
import { Footer } from '../Footer';
import SolutionTask from "./SolutionTask";

export default class SolutionBoard extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: 1,
            caller: props.Caller,
            controllerName: 'solution',
            data: null,
            loading: true,
            workFlowSteps: [],
            sorts: [],
            systemModuleId: 24,
            moduleAccessStatus: 1
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.addKeyDown();
                this.refreshData();
            });
    }
    refreshData() {
        var solutionId = this.getCurrentFormId();
        var p1 = new Promise((resolve, reject) => {
            this.httpPost("/api/v1/solution/workflow/step/list", {
                filters: {
                    solutionId: solutionId,
                    workFlowId: this.getDefaultGuid(),
                }
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        this.state.workFlowSteps = data.records;
                        this.state.data = data;
                    }
                    resolve(true);
                });
        });
        var p2 = new Promise((resolve, reject) => {
            this.httpPost("/api/v1/solution/task/all/list", {
                solutionId: solutionId,
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        this.state.tasks = data.records;
                    }
                    resolve(true);
                });
        });

        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            });
        });
    }
    getWorkFlows() {
        var list = [];
        this.state.workFlowSteps.forEach(f => {
            var find = 0;
            list.forEach(l => {
                if (f.workflowId === l.id) find = 1;
            });
            if (find === 0) list.push({ id: f.workflowId, title: f.workflowTitle })
        });
        return list;
    }
    showTaskDo(record,readOnly=true) {
        this.removeKeyDown();
        this.showComponents({
            component: <TaskDo Caller={this} Record={record} ReadOnly={readOnly} />
        });
    }
    onAddTask() {
        var solutionId = this.getCurrentFormId();
        this.removeKeyDown();
        this.showComponents({ component: <SolutionTask Caller={this} SolutionId={solutionId} /> });
    }
    onEditTask(id) {
        var solutionId = this.getCurrentFormId();
        this.removeKeyDown();
        this.showComponents({ component: <SolutionTask Caller={this} Id={id} SolutionId={solutionId} /> });
    }
    getTaskCount(stepId) {
        var c = 0;
        this.state.tasks.forEach(record => {
            if (record.solutionWorkFlowStepId === stepId) c++;
        });
        return c;
    }
    getTasks(stepId) {
        var t = [];
        this.state.tasks.forEach(record => {
            if (record.solutionWorkFlowStepId === stepId) t.push(record);
        });
        if (this.getSort(stepId) === 1) return t.sort(function (a, b) {
            return ((b.assignDateString < a.assignDateString) ? -1 : ((b.assignDateString == a.assignDateString) ? 0 : 1));
        });
        if (this.getSort(stepId) === 2) return t.sort(function (a, b) {
            return ((a.assignDateString < b.assignDateString) ? -1 : ((a.assignDateString == b.assignDateString) ? 0 : 1));
        });
        if (this.getSort(stepId) === 3) return t.sort(function (a, b) {
            return ((b.priorityId < a.priorityId) ? -1 : ((b.priorityId == a.priorityId) ? 0 : 1));
        });
        if (this.getSort(stepId) === 4) return t.sort(function (a, b) {
            return ((a.priorityId < b.priorityId) ? -1 : ((a.priorityId == b.priorityId) ? 0 : 1));
        });
        return t;
    }
    getSort(stepId) {
        var v = 1;
        this.state.sorts.forEach(f => {
            if (f.stepId === stepId) v = f.value;
        });
        return v;
    }
    setSort(stepId, e) {
        var find = 0;
        this.state.sorts.forEach(f => {
            if (f.stepId === stepId) {
                find = 1;
                f.value = e;
            }
        });
        if (find === 0) this.state.sorts.push({ stepId: stepId, value: e });
        this.setState({ data: this.state.data });
    }
    renderForm() {
    if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    {this.getWorkFlows().map(flow =>
                        <div style={{ "overflow-x": "hidden" }}>
                            <div className="mb-2" style={{"display": "flex","align-items": "center","justify-content": "space-between"}}>
                            <h4>گردش کار {flow.title}</h4>
                                <a className="btn btn-primary" onClick={e => this.onAddTask()}>افزودن وظیفه جدید به این گردش کاری</a>
                            </div>
                            {this.state.workFlowSteps.map(step => step.workflowId === flow.id &&
                                <div class="card text-white bg-white" style={{ "width": "320px", "float": "right", "margin-left": "25px", "margin-top": "0", "margin-bottom": "25px","height": "400px" }}>
                                    <div class="card-header" style={{ "background-color": (this.isBlank(step.color) ? "#f8a602" : step.color) }}>{step.step} - {step.title}</div>
                                    <div class="card-inner" style={{ "overflow-y": "scroll" }}>
                                        <div className="solution_cart_holder">
                                            <select defaultValue={this.getSort(step.id)} onChange={e => this.setSort(step.id, parseInt(e.target.value))} class="form-control text-center">
                                                <option value="1">جدیدترین</option>
                                                <option value="2">قدیمی ترین</option>
                                                <option value="3">اولویت بالا</option>
                                                <option value="4">اولویت کم</option>
                                            </select>
                                            <span className="badg" style={{ "background-color": (this.isBlank(step.color) ? "#f8a602" : step.color) }}>{this.getTaskCount(step.id)}</span>
                                        </div>
                                        {this.getTasks(step.id).map(record => <div className="project">
                                            <div className="project-head">
                                                <a onClick={e => this.showTaskDo(record)} className="hand project-title">
                                                    <div className="project-info">
                                                        <span class="text-black">{record.title}</span>
                                                        <span className="sub-text">مسئول جاری: {record.currentUserName}</span>
                                                        <span className="sub-text">تاریخ تخصیص: {record.assignDateString}</span>
                                                        {record.priorityId === 1 && <span className="text-success">اولویت عادی</span>}
                                                        {record.priorityId === 2 && <span className="text-success">اولویت فوری</span>}
                                                        {record.priorityId === 3 && <span className="text-warning">اولویت کم</span>}
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="project-meta" style={{ "border-bottom": "solid 1px #e8e8e8", "padding-bottom": "10px", "margin-bottom": "10px" }}>
                                                <a onClick={e => this.showTaskDo(record, true)} className="hand">
                                                    <span className="nk-menu-text text-warning"><em className="icon ni ni-eye"></em> مشاهده سابقه</span>
                                                </a>
                                                {record.currentUserId === this.state.data.global.user.id && <a onClick={e => this.showTaskDo(record, false)} className="hand">
                                                    <span className="nk-menu-text text-success"><em className="icon ni ni-report-profit"></em> انجام</span>
                                                </a>}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </div>)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}